import { Link } from 'react-router-dom';

export default function AboutSEOSection() {
  return (
    <section className="relative py-20 md:py-28 px-6 md:px-10 bg-primary-600 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-700 via-primary-600 to-primary-800 opacity-90"></div>

      <div className="relative z-10 max-w-[1280px] mx-auto">
        <div className="mb-20">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-accent-400/30 text-accent-200 text-xs font-medium mb-6">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-300"></span>
            SEO Guide
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div>
              <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-6">
                What is OOPBuy Spreadsheet?
              </h2>
              <p className="text-base md:text-lg text-background-100/80 leading-relaxed mb-4">
                <strong>OOPBuy Spreadsheet</strong> is a structured digital system used for organizing product listings, comparing prices, and managing purchases through a spreadsheet-based interface.
              </p>
              <p className="text-base text-background-100/70 leading-relaxed mb-4">
                It is commonly used in modern online shopping workflows where users want better product comparison visibility, organized purchasing data, faster decision-making systems, and simplified shopping management tools.
              </p>
              <p className="text-base text-background-100/70 leading-relaxed mb-8">
                The <strong>spreadsheet shopping system</strong> approach makes it easier to track multiple products across different categories, compare prices at a glance, and make informed purchasing decisions — all from one centralized view.
              </p>

              <Link
                to="/oopbuy-spreadsheet-guide"
                onClick={() => window.scrollTo(0, 0)}
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-primary-700 font-semibold rounded-full hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                Read Full Article
                <i className="ri-arrow-right-line text-base"></i>
              </Link>
            </div>

            <div className="flex items-start justify-center lg:justify-end">
              <div className="w-full max-w-[400px] aspect-square rounded-2xl overflow-hidden bg-primary-800/30">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20workspace%20with%20an%20iMac%20displaying%20a%20beautifully%20organized%20spreadsheet%20interface%20with%20product%20listings%2C%20warm%20desk%20lamp%20glow%2C%20ceramic%20coffee%20cup%20and%20small%20succulent%20plant%2C%20soft%20evening%20ambiance%2C%20professional%20home%20office%2C%20warm%20amber%20and%20slate%20tones%2C%20inviting%20productivity%20aesthetic&width=800&height=800&seq=about-seo-v2&orientation=squarish"
                  alt="OOPBuy Spreadsheet system overview"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          <div className="mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {benefits.map((b, i) => (
              <div key={i} className="bg-primary-500/30 rounded-xl p-6 backdrop-blur-sm">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-400/30 text-accent-200 mb-4">
                  <i className={`${b.icon} text-lg`}></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-background-50 mb-2">
                  {b.title}
                </h3>
                <p className="text-sm text-background-100/70 leading-relaxed">
                  {b.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

const benefits = [
  {
    icon: 'ri-bar-chart-box-line',
    title: 'Structured Comparison',
    desc: 'Organize and compare multiple product listings side by side for faster, smarter decisions.',
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Faster Decisions',
    desc: 'Streamlined data presentation helps you identify the best options without information overload.',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Price Tracking',
    desc: 'Easily monitor prices across different sellers and catch the best deals at a glance.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Centralized Management',
    desc: 'Keep all your shopping data organized in one accessible, easy-to-navigate system.',
  },
];